import React from 'react';
import { navigateTo, PageComponentId } from '@wix/business-manager-api';

import { PopoverMenu, Button } from 'wix-style-react';
import { ChevronDown } from 'wix-ui-icons-common';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { datahooks } from '../constants';
import { ModuleRegistry } from 'react-module-container';
import { crmHomeMethodNames } from '../../crm-actions';
import { CrmHomeBiLogger } from '../../bi-logger';

export interface CreateNewMenuProps extends InjectedTranslateProps {
  biLogger: CrmHomeBiLogger;
}

export const CreateNewMenuComponent: React.FC<CreateNewMenuProps> = (props) => {
  const { t, biLogger } = props;

  return (
    <PopoverMenu
      dataHook={datahooks.homeCreateNewMenu}
      maxWidth={216}
      triggerElement={({ toggle }) => (
        <Button
          skin="light"
          dataHook={datahooks.homeCreateNewMenuButton}
          height="medium"
          onClick={() => {
            biLogger.reportCreateNewButtonClick();
            toggle();
          }}
          suffixIcon={<ChevronDown />}
        >
          {t('createNewMenu.button')}
        </Button>
      )}
    >
      <PopoverMenu.MenuItem
        dataHook={datahooks.homeCreateNewMenuItem('contact')}
        onClick={() => {
          biLogger.reportCreateNewOptionClick('contact');
          ModuleRegistry.invoke(crmHomeMethodNames.createContact);
        }}
        text={t('createNewMenu.items.contact')}
      />
      <PopoverMenu.MenuItem
        dataHook={datahooks.homeCreateNewMenuItem('message')}
        onClick={() => {
          biLogger.reportCreateNewOptionClick('message');
          navigateTo({
            pageComponentId: PageComponentId.Engage,
            contextData: {
              referrer: 'crmHome',
            },
          });
        }}
        text={t('createNewMenu.items.message')}
      />
      <PopoverMenu.MenuItem
        dataHook={datahooks.homeCreateNewMenuItem('form')}
        onClick={() => {
          biLogger.reportCreateNewOptionClick('form');
          ModuleRegistry.invoke(crmHomeMethodNames.addForm);
        }}
        text={t('createNewMenu.items.form')}
      />
      <PopoverMenu.Divider />
      <PopoverMenu.MenuItem
        dataHook={datahooks.homeCreateNewMenuItem('automation')}
        onClick={() => {
          biLogger.reportCreateNewOptionClick('automation');
          navigateTo({
            pageComponentId: PageComponentId.Triggers,
            contextData: {
              appState: 'rules/create',
              referrer: 'crmHome',
            },
          });
        }}
        text={t('createNewMenu.items.automation')}
      />
      <PopoverMenu.MenuItem
        dataHook={datahooks.homeCreateNewMenuItem('task')}
        onClick={() => {
          biLogger.reportCreateNewOptionClick('task');
          navigateTo({
            pageComponentId: PageComponentId.TasksWeb,
            contextData: {
              referrer: 'crmHome',
            },
          });
        }}
        text={t('createNewMenu.items.task')}
      />
      <PopoverMenu.MenuItem
        dataHook={datahooks.homeCreateNewMenuItem('workflow')}
        onClick={() => {
          biLogger.reportCreateNewOptionClick('workflow');
          navigateTo({
            pageComponentId: PageComponentId.Workflow,
            contextData: {
              referrer: 'crmHome',
            },
          });
        }}
        text={t('createNewMenu.items.workflow')}
      />
      <PopoverMenu.Divider />
      <PopoverMenu.MenuItem
        dataHook={datahooks.homeCreateNewMenuItem('priceQuote')}
        onClick={() => {
          biLogger.reportCreateNewOptionClick('priceQuote');
          navigateTo({
            pageComponentId: PageComponentId.PriceQuotes,
            viewId: 'create-price-quote',
            contextData: {
              appState: 'create',
              referrer: 'crmHome',
            },
          });
        }}
        text={t('createNewMenu.items.priceQuote')}
      />
      <PopoverMenu.MenuItem
        dataHook={datahooks.homeCreateNewMenuItem('invoice')}
        onClick={() => {
          biLogger.reportCreateNewOptionClick('invoice');
          navigateTo({
            pageComponentId: PageComponentId.Invoices,
            viewId: 'create-invoice',
            contextData: {
              appState: 'create',
              referrer: 'crmHome',
            },
          });
        }}
        text={t('createNewMenu.items.invoice')}
      />
    </PopoverMenu>
  );
};

export const CreateNewMenu = translate()(CreateNewMenuComponent);
